module.exports = __webpack_public_path__ + "img/placard_02.7854baa7.png";